const useBuildAssistantPromptKeyDown = (
  prompt: string,
  isGenerating: boolean,
  onSubmit: () => void,
) => {
  // NOTE (Cole, 2025-04-04): I'm using onKeyDown to take higher precedence over onKeyPress here. We must do this because otherwise a selected editable component will blur the editor component when the user presses enter rather than submitting the build assistant prompt.
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (
      e.key === "Enter" &&
      !e.shiftKey &&
      !isGenerating &&
      prompt.trim() !== ""
    ) {
      e.preventDefault();
      e.stopPropagation();
      onSubmit();
    }
  };

  return handleKeyDown;
};

export default useBuildAssistantPromptKeyDown;
